import { Component, Input, OnInit, ElementRef, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { DocumentItem } from '../document-models/document-item';
import { DocumentService } from 'src/services/document.service';
import { takeUntil } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';

declare const reloadCaptcha: Function;
declare const openFeedbackForm: Function;
@Component({
  selector: 'app-cps-drug-summary-document',
  templateUrl: './cps-drug-summary-document.component.html',
  styleUrls: ['./cps-drug-summary-document.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CpsDrugSummaryDocumentComponent implements OnInit {


  @Input() htmlElement: HTMLElement;
  @ViewChild('docWrapper') documentWrapperElement: ElementRef;
  public doc: DocumentItem;

  public contentLoaded = false;

  private destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  constructor(private documentService: DocumentService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.checkContentLoaded();
  }

  checkContentLoaded(): void {
    const thizz = this;
    this.documentService.getContentLoaded().pipe(takeUntil(this.destroy$)).subscribe(isLoaded => {
      thizz.contentLoaded = isLoaded;
      thizz.changeDetector.detectChanges();
    });
  }

	betaFeedback(): void {
		openFeedbackForm();
	}

  renderCaptcha(): void {
    reloadCaptcha();
  }
}
